/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scheduleRiskCausingDescendantSchema } from './scheduleRiskCausingDescendantSchema';

export const scenarioItemRiskInfoSchema = z.object({
  descendantsNeedingAttentionCount: z.int(),
  earliestAncestorDeadlineDateTime: z.iso.datetime().nullish(),
  earliestAncestorDeadlineSourceItemId: z.int().nullish(),
  earliestAncestorDeadlineSourceItemName: z.string().nullish(),
  riskCausingDescendantCount: z.int(),
  get topDescendantsNeedingAttention() {
    return z.array(scheduleRiskCausingDescendantSchema);
  },
  get topRiskCausingDescendants() {
    return z.array(scheduleRiskCausingDescendantSchema);
  },
});
